export const gridRowHeightInteger = 36;

/**
 * TODO: This contains both regTypes and configTypes. This could be refactored later
 * to make the separation between regTypes and configTypes clearer
 */
export const configTypes = {
  STR: 'str',
  LTR: 'ltr',
  INSPECTIONS: 'inspections',
  UNREGISTERED: 'unregistered',
  UNKNOWN: 'unknown',
  /**
   * The distinction between UNLICLIVESTR and UNPERMITTED_LIVE_STR is whether the
   * value of "license_type" (in the db) for the license is either "str" or "permit".
   */
  UNLICLIVESTR: 'unliclivestr',
  UNPERMITTED_LIVE_STR: 'unpermitted_live_str',
  STR_LICENSE: 'strlicense',
  TOT_LICENSE: 'tot',
  UNLICSTR: 'unlicstr',
  WAITLIST: 'waitlist',
};

export const licenseConfigTypes = [
  configTypes.STR_LICENSE,
  configTypes.WAITLIST,
  configTypes.TOT_LICENSE,
];

export const fileNames = {
  [configTypes.STR]: 'short-term-licensed-properties', // Short-Term Licensed Properties
  [configTypes.UNREGISTERED]: 'all-unlicensed-properties', // All Unlicensed Properties
  [configTypes.UNKNOWN]: 'unidentified-listings', // Unidentified Listings
  [configTypes.UNLICLIVESTR]: 'unlicensed-live-str-properties', // Unlicensed Live STR Properties
  [configTypes.UNPERMITTED_LIVE_STR]: 'unpermitted-live-str-properties', // Un-permitted Live STR Properties
  [configTypes.STR_LICENSE]: 'str-licenses', // STR Licenses
  [configTypes.TOT_LICENSE]: 'tot-licenses', // TOT Licenses
  [configTypes.WAITLIST]: 'waitlist-applications',
  [configTypes.INSPECTIONS]: 'inspections',
  [configTypes.LTR]: 'long-term-rental',
};

export const listDataKeys = {
  LISTINGS: 'listings',
  LICENSES: 'licenses',
};

export const allowCreateCitation = [
  configTypes.STR,
  configTypes.LTR,
  configTypes.UNLICLIVESTR,
];

export const GANT_DAY_BOX_WIDTH = 36;

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const SUNDAY = 0;

export const SATURDAY = 6;

export const NO_DATA_ROW_COUNT = 0;

/* Calculates constant for date one week ago. This is used in order to determine
  if a listing's diffStatus is new/updated. This is calculated aprioristically in order
  to avoid running this code for every row */
const datePlaceholder = new Date();
datePlaceholder.setDate(datePlaceholder.getDate() - 7);
export const DATE_ONE_WEEK_AGO = datePlaceholder;

export const NEW_LISTING = 'new';

export const UPDATED_LISTING = 'updated';

export const LICENSES_URL_PATH = '/licenses?pageSize=500';

export const WAITLISTED_LICENSES_URL_PATH = '/waitlistLicenses';

export const LISTINGS_URL_BASE_PATH = '/listings';
